export enum ReceiptNotificationType {
  Email = 'EMAIL',
}